/* NELLAE — neutral interaction events for the custom pixel (GA4 only). Standard commerce events are sent by
   Shopify itself and are not duplicated here. Event names and parameters carry no health terms (docs/12 §3.2).
   Publishing respects visitor consent because custom pixels run inside Shopify's Web Pixels sandbox. */
(function () {
  'use strict';

  var Nellae = (window.Nellae = window.Nellae || {});
  var enabled = !!(Nellae.config && Nellae.config.publishEvents);

  var publish = function (name, payload) {
    if (!enabled) return;
    var detail = payload || {};
    document.dispatchEvent(new CustomEvent('nellae:analytics', { detail: { name: name, payload: detail } }));
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, detail);
      }
    } catch (e) { /* never break the page for analytics */ }
  };
  Nellae.publish = publish;

  var once = function (key) {
    try {
      if (window.sessionStorage.getItem('nellae_evt_' + key)) return false;
      window.sessionStorage.setItem('nellae_evt_' + key, '1');
    } catch (e) { /* private mode: fall through and send */ }
    return true;
  };

  document.addEventListener('nellae:offer-change', function (event) {
    if (!event.detail || !event.detail.byUser) return;
    publish('offer_' + event.detail.offer + '_bottle_selected', { source: event.detail.source });
  });

  document.addEventListener('nellae:subscription-selected', function (event) {
    publish('subscription_selected', { source: event.detail && event.detail.source });
  });

  document.addEventListener('nellae:atc', function (event) {
    publish('atc_source', event.detail);
  });

  document.addEventListener('nellae:sheet-open', function () { publish('selector_sheet_opened', {}); });

  document.addEventListener('nellae:cart-replaced', function (event) {
    publish('cart_offer_replaced', event.detail);
  });

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-nellae-faq] > summary');
    if (summary) {
      var item = summary.parentElement;
      if (!item.open) publish('faq_opened', { item: item.getAttribute('data-nellae-faq') });
      return;
    }
    var labelImage = event.target.closest('[data-nellae-event="supplement_facts_opened"]');
    if (labelImage && once('supplement_facts_image')) publish('supplement_facts_opened', { mode: 'image' });
  });

  if ('IntersectionObserver' in window) {
    var timers = new Map();
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var name = entry.target.getAttribute('data-nellae-observe-name');
        if (entry.isIntersecting) {
          timers.set(entry.target, window.setTimeout(function () {
            if (!once(name)) return;
            publish(name, name === 'supplement_facts_opened' ? { mode: 'view' } : {});
            sectionObserver.unobserve(entry.target);
          }, 1000));
        } else if (timers.has(entry.target)) {
          window.clearTimeout(timers.get(entry.target));
          timers.delete(entry.target);
        }
      });
    }, { threshold: [0.5] });
    document.querySelectorAll('[data-nellae-observe]').forEach(function (el) {
      /* tall sections may never reach 50% of their own height in a short viewport */
      var target = el.querySelector('.nellae-section-head') || el;
      target.setAttribute('data-nellae-observe-name', el.getAttribute('data-nellae-observe'));
      sectionObserver.observe(target);
    });
  }

  var marks = [25, 50, 75, 100];
  var sent = {};
  var onScroll = function () {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var pct = Math.round((window.scrollY / max) * 100);
    marks.forEach(function (mark) {
      if (pct >= mark && !sent[mark]) { sent[mark] = true; publish('scroll_depth', { pct: mark }); }
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();
